export const BACKEND_NAME = 'gitlab';
export const BACKEND_LABEL = 'GitLab';

export const DEFAULT_API_ROOT = 'https://gitlab.com/api/v4';
export const DEFAULT_AUTH_ROOT = 'https://gitlab.com';
export const DEFAULT_AUTH_PATH = 'oauth/authorize';
